import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail, Save } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { Field, inp } from "@/components/admin/AdminUi";
import { WEEKDAYS } from "./utils";

export function SettingsDialog({ open, cfg, onClose, onSaved }) {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => { if (open && cfg) setF({ ...cfg }); }, [open, cfg]);
  if (!f) return null;
  const toggleDay = (i) => setF({ ...f, reminder_days: f.reminder_days.includes(i) ? f.reminder_days.filter((x) => x !== i) : [...f.reminder_days, i] });
  const save = async () => {
    const th = parseInt(f.threshold_days, 10);
    if (!(th >= 1 && th <= 60)) return toast.error("I giorni per il promemoria devono essere tra 1 e 60");
    if (f.reminder_enabled && !f.reminder_email.trim()) return toast.error("Inserisci l'email a cui inviare il promemoria");
    setBusy("save");
    try {
      const { data } = await api.put("/admin/counter-orders/settings", { ...f, threshold_days: +f.threshold_days, reminder_hour: +f.reminder_hour });
      toast.success("Impostazioni salvate");
      onSaved(data);
    } catch (x) { toast.error(errMsg(x)); }
    setBusy("");
  };
  const test = async () => {
    setBusy("test");
    try {
      const { data } = await api.post("/admin/counter-orders/reminder/send");
      toast[data.status === "sent" ? "success" : "info"](data.status === "sent" ? `Promemoria inviato a ${data.to}` : "Nessun ordine fermo oltre la soglia: non viene inviato nulla");
    } catch (x) { toast.error(errMsg(x)); }
    setBusy("");
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="counter-settings-dialog">
        <DialogHeader><DialogTitle className="text-2xl font-extrabold uppercase">Impostazioni</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <Field label="Messaggio WhatsApp al cliente (usa {nome}, {articolo} e {codice}: se manca {codice}, il codice viene aggiunto in fondo)">
            <textarea data-testid="counter-wa-message-input" rows={3} className={inp + " h-auto py-2"} value={f.wa_message} onChange={(e) => setF({ ...f, wa_message: e.target.value })} />
          </Field>
          <Field label="Promemoria dopo quanti giorni in sospeso">
            <input data-testid="counter-threshold-input" type="number" min="1" max="60" className={inp.replace("w-full", "w-28")} value={f.threshold_days} onChange={(e) => setF({ ...f, threshold_days: e.target.value })} />
          </Field>
          <div className="rounded-lg border p-3 space-y-3 bg-slate-50">
            <label className="flex items-center gap-2 text-sm font-semibold">
              <input type="checkbox" data-testid="counter-reminder-enabled" className="w-4 h-4 accent-brand-navy" checked={f.reminder_enabled} onChange={(e) => setF({ ...f, reminder_enabled: e.target.checked })} />
              <Mail className="w-4 h-4 text-brand-navy" /> Email automatica degli ordini fermi
            </label>
            <Field label="Invia a"><input data-testid="counter-reminder-email" type="email" className={inp} value={f.reminder_email} onChange={(e) => setF({ ...f, reminder_email: e.target.value })} /></Field>
            <div className="flex flex-wrap items-end gap-3">
              <Field label="Ora">
                <select data-testid="counter-reminder-hour" className={inp.replace("w-full", "w-24")} value={f.reminder_hour} onChange={(e) => setF({ ...f, reminder_hour: e.target.value })}>
                  {Array.from({ length: 24 }, (_, h) => <option key={h} value={h}>{String(h).padStart(2, "0")}:00</option>)}
                </select>
              </Field>
              <div className="flex gap-1" data-testid="counter-reminder-days">
                {WEEKDAYS.map((d, i) => (
                  <button type="button" key={d} data-testid={`counter-day-${i}`} onClick={() => toggleDay(i)}
                    className={`press h-10 w-11 rounded-md border text-xs font-semibold ${f.reminder_days.includes(i) ? "bg-brand-navy text-white border-brand-navy" : "bg-white"}`}>{d}</button>
                ))}
              </div>
            </div>
            <p className="text-[11px] text-slate-500">Parte da sola dal server, anche a computer spento. Se non ci sono ordini fermi non arriva nulla.</p>
            <button type="button" data-testid="counter-reminder-test-btn" onClick={test} disabled={!!busy} className="press h-9 px-3 rounded-md border border-brand-navy text-brand-navy text-xs font-semibold flex items-center gap-1 disabled:opacity-60">
              {busy === "test" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Mail className="w-3.5 h-3.5" />} Invia ora il promemoria
            </button>
          </div>
          <button data-testid="counter-settings-save-btn" onClick={save} disabled={!!busy} className="press w-full h-11 rounded-md bg-brand-yellow text-brand-navy font-semibold flex items-center justify-center gap-2 disabled:opacity-60">
            {busy === "save" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salva impostazioni
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
